import JsonForm from '../JsonSchemaFiller/JsonForm';

import useInputsFormData from '../pageState/steps/useInputsFormData';
import setInputsFormData from '../pageState/steps/setInputsFormData';

import IWorkflowDefinitionDetails from 'types/IWorkflowDefinitionDetails';

interface IProps {
  workflowDefinitionDetails: IWorkflowDefinitionDetails;
}

export default function InputsForm(props: IProps) {
  const schema = props.workflowDefinitionDetails.inputs_schema.inputs || {};

  const formData = useInputsFormData();

  return (
    <JsonForm
      schema={schema}
      formData={formData}
      setFormData={setInputsFormData}
    />
  );
}
